// ##### Komarov 2025-07-18
import React, { useState } from 'react';
// ##### 25-05-21 Komarov
import IconHint from './iconHint';
// ##### 23-11-01 Komarov
import { Media } from '../../../helpers/MediaConfig';

// ##### Komarov 2025-07-18
const SvgTag = ({ style = null, color, onSmallScreen, setIsHintShown, setY }) => {
  // ##### 24-08-16 Komarov
  const [crossColor, setCrossColor] = useState(color ? color : '#102D69');

  // ##### 24-08-16 Komarov
  const onMouseEnter = e => {
    if (!color) {
      return;
    }
    setCrossColor((!onSmallScreen && 'yellow') || color);
    setIsHintShown(true);
    setY(e.clientY + 5);
  };

  // ##### 24-08-16 Komarov
  const onMouseLeave = () => {
    if (!color) {
      return;
    }
    setCrossColor(color);
    setIsHintShown(false);
    setY(undefined);
  };

  return (
    <svg
      style={style}
      // ##### 23-11-01 Komarov
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      color={crossColor}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 93.52 122.88"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      {/* ##### 23-04-04 Komarov */}
      <g>
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.46,0h13.33c0.25,0,0.46,0.21,0.46,0.46v44.21l0.29-0.3l0.08-0.08c3.18-3.48,5.78-6.26,9.1-8.14 c3.36-1.9,7.4-2.84,13.42-2.58l0.01,0c2.15,0.03,4.69,0.26,6.78,0.46c0.97,0.09,1.84,0.17,2.59,0.22 c10.16,0.67,14.92,6.01,18.62,10.17c1.63,1.84,3.05,3.42,4.57,4.15c0.72,0.34,1.85-0.14,3.14-0.68c0.78-0.33,1.6-0.68,2.47-0.91 c0.56-0.21,0.87-0.33,1.11-0.42c0.31-0.12,0.52-0.2,0.64-0.24l9.24-3.66l0.04-0.01c1.24-0.42,2.68-0.16,3.95,0.59 c0.89,0.53,1.71,1.31,2.3,2.26c0.59,0.96,0.95,2.1,0.94,3.36c-0.01,1.81-0.81,3.83-2.82,5.83c-0.09,0.09-0.19,0.15-0.3,0.18 l-9.26,3.67l0,0l-0.86,0.3c-4.96,1.76-8.55,3.03-14.84,1.48c-0.05-0.01-0.09-0.03-0.13-0.05c-4.4-1.71-6.68-4.08-8.9-6.4 l-0.33-0.34l-2.81,17.91c2.51,1.58,5.02,2.75,7.39,3.86c7.2,3.36,13.12,6.12,14.39,17.43c0.23,2.03,0.12,3.94,0.01,6.02l0,0.03 c-0.02,0.3-0.03,0.63-0.07,1.4l-0.88,21.91c-0.02,0.43-0.38,0.76-0.8,0.75l-11.13,0.03c-0.43,0-0.78-0.35-0.78-0.78 c0.12-7.55,0.34-15.46,0.73-23l0.06-1.02c0.06-1.18,0.12-2.27,0.06-3.29c-0.06-0.97-0.24-1.88-0.64-2.75l-0.11-0.23 c-0.45-0.98-0.86-1.88-1.48-2.17c-1.23-0.57-3.18-1.28-5.4-2.01c-2.54-0.84-5.38-1.68-7.88-2.39c-1.84,6.08-4.33,13.44-7,20.43 c-2.39,6.24-4.92,12.21-7.27,16.74c-0.14,0.28-0.44,0.44-0.73,0.42l-11.69,0.06c-0.43,0-0.78-0.34-0.78-0.77 c0-0.1,0.02-0.2,0.06-0.29l0,0c2.34-5.75,5.1-13.22,7.75-20.81c2.71-7.77,5.31-15.69,7.23-22.05c-1.14-1.4-2.23-2.96-2.97-4.68 c-0.82-1.9-1.22-3.96-0.81-6.17l4.01-21.66l-0.23-0.01c-1.39-0.06-2.55-0.11-3.88,0.47c-1.82,0.8-3.26,2.42-4.86,4.22 c-0.65,0.73-1.32,1.49-2.09,2.27l-0.05,0.05c-0.57,0.59-1.17,1.2-1.73,1.77l-7.08,7.15c-0.11,0.11-0.24,0.18-0.38,0.21v59.84 c0,0.25-0.21,0.46-0.46,0.46H0.46c-0.25,0-0.46-0.21-0.46-0.46V0.46C0,0.21,0.21,0,0.46,0L0.46,0z M47.34,6.41 c3.18-1.09,6.51-0.78,9.31,0.59c2.8,1.37,5.08,3.82,6.17,7c1.09,3.18,0.78,6.51-0.59,9.31c-1.37,2.8-3.82,5.08-7,6.17 c-3.18,1.09-6.51,0.78-9.31-0.59c-2.8-1.37-5.08-3.82-6.17-7c-1.09-3.18-0.78-6.51,0.59-9.31C41.71,9.78,44.15,7.5,47.34,6.41 L47.34,6.41z M3.07,39.71h3.08v14.75H3.07V39.71L3.07,39.71z"
        />
      </g>
    </svg>
  );
};

// ##### Komarov 2025-07-18
const SignOut = ({ color, hintText, onSmallScreen }) => {
  const [isHintShown, setIsHintShown] = useState(false);
  const [y, setY] = useState(undefined);

  return (
    <div
      data-component="SignOut"
      style={{
        position: 'relative',
        zIndex: 2001,
      }}
    >
      {/* ##### 23-11-01 Komarov */}
      <Media lessThan="Mobile-M-375-425">
        <SvgTag
          style={{
            width: '7.5vw',
            enableBackground: 'new 0 0 95.95 122.88',
          }}
          color={color}
          onSmallScreen={onSmallScreen}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <Media at="Mobile-M-375-425">
        <SvgTag
          style={{
            height: '2.14em',
            enableBackground: 'new 0 0 95.95 122.88',
          }}
          color={color}
          onSmallScreen={onSmallScreen}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <Media at="Mobile-L-425-768">
        <SvgTag
          style={{
            height: '8vw',
            enableBackground: 'new 0 0 93.52 122.88',
          }}
          color={color}
          onSmallScreen={onSmallScreen}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <Media at="Tablet-768-1024">
        <SvgTag
          style={{
            height: '6vw',
            enableBackground: 'new 0 0 93.52 122.88',
          }}
          color={color}
          onSmallScreen={onSmallScreen}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <SvgTag
          style={{
            height: '2.2vw',
            enableBackground: 'new 0 0 95.95 122.88',
          }}
          color={color}
          onSmallScreen={onSmallScreen}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <IconHint isHintShown={isHintShown} hintText={hintText} y={y} />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default SignOut;
